<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>CMS Blog</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{name: 'Home'}">Home</router-link>
              </li>
              <li class="breadcrumb-item active">CMS Blog</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="overlay" v-if="is_loading">
        <i class="fas fa-2x fa-sync-alt fa-spin"></i>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="overlay" v-if="is_loading">
              <i class="fas fa-2x fa-sync-alt fa-spin"></i>
            </div>
            <div class="card-header">
              <h3 class="card-title">Detail</h3>
              <div class="card-tools">
                <router-link class="btn btn-info" :to="{name: 'CMSBlogList'}">
                  <i class="fas fa-list"></i> List
                </router-link>
              </div>
            </div>
            <div class="card-body">
              <div class="custom-list">
                <ul>

                  <li><strong>ID</strong> {{ value.id }}</li>

                  <li><strong>Title</strong> {{ value.blog_title }}</li>

                  <li><strong>Slug URL</strong> {{ value.blog_slug }}</li>

                  <li><strong>Category</strong>
                      <span v-if="!_.isNil(value.blog_category_id)">{{ pre.blog_category_id[value.blog_category_id] }}</span>
                    </li>

                  <li><strong>Blog Subcategory</strong>
                      <span v-if="!_.isNil(value.blog_subcategory_id)">{{ pre.blog_subcategory_id[value.blog_subcategory_id] }}</span>
                    </li>

                  <li><strong>Summary</strong> {{ value.blog_summary }}</li>

                  <li><strong>Content</strong> <p v-html="value.blog_content"/></li>

                  <li><strong>Blog Featured Image</strong>
                      <img v-bind:src="API_ASSET_UPLOAD_URL+value.blog_featured_image" class="img-fluid img-thumbnail rounded" style="width: 200px;">
                      </li>

                  <li><strong>Tagline</strong> {{ value.blog_tagline }}</li>

                  <li><strong>View Count</strong> {{ value.view_count }}</li>

                  <li><strong>Blog Tags</strong> {{ value.blog_tages }}</li>

                  <li><strong>Blog SEO Title</strong> {{ value.blog_seo_title }}</li>

                  <li><strong>SEO Image</strong>
                      <img v-bind:src="API_ASSET_UPLOAD_URL+value.blog_seo_image" class="img-fluid img-thumbnail rounded" style="width: 200px;">
                      </li>

                  <li><strong>SEO Summary</strong> {{ value.blog_seo_summary }}</li>

                  <li><strong>SEO Keywords</strong> {{ value.blog_seo_keywords }}</li>

                  <li><strong>Status</strong> {{ value.status }}</li>

                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

    </section>
  </div>
</template>

<script>
//import MasterLayout from "@/components/layouts/MasterLayoutComponent.vue";
import {DepartmentsAPI} from "@/services/api";
import axios from "axios";
const fileDownload = require("js-file-download")
import { Notification } from "element-ui";


export default {
  name: "CMSBlogShow",
  metaInfo: {
    title: "CMS Blog | Dotlines"
  },
  data: () => ({
    value: {

    },
    pre: {
      blog_category_id: [],blog_subcategory_id: [],
    },
    is_loading: false
  }),
  mounted: function () {
    this.initialize();
  },
  methods: {
    blogCategoryIdOptions: function () {
      return new Promise(resolve => {
        axios.get("/get-dropdown-options/6")
          .then(response => {
            resolve(response.data);
          })
          .catch((error) => {
            console.log("error " + error);
            resolve(error);
          });
      });
    },
    blogSubcategoryIdOptions: function () {
      return new Promise(resolve => {
        axios.get("/get-dropdown-options/1")
          .then(response => {
            resolve(response.data);
          })
          .catch((error) => {
            console.log("error " + error);
            resolve(error);
          });
      });
    },

    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;

      await this.blogCategoryIdOptions().then(blog_category_id => {
        this.pre.blog_category_id = blog_category_id;
      });
      await this.blogSubcategoryIdOptions().then(blog_subcategory_id => {
        this.pre.blog_subcategory_id = blog_subcategory_id;
      });


      await this.getDetail(this.params.id).then(response => {
        this.value = response.data;
      });

      this.is_loading = false;
    },
    downloadFile: function(url) {
      this.is_loading = true;
      axios.get(this.API_ASSET_UPLOAD_URL+url, {responseType: "arraybuffer"})
        .then(response => {
          fileDownload(response.data, url.replaceAll("/", "-"));
          Notification.success({title: "Download Completed", message: "Download completed successfully", type: "success"});
        })
        .catch(error => {
          Notification.error({title: "Download Failed", message: "Failed to download", type: "error"});
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        let api_url = "/cms_blogs/" + id;
        axios.get(api_url)
          .then(response => {
            resolve(response);
          })
          .catch((error) => {
            console.log("error " + error);
            reject(error);
          })
          .finally(() => {
          });
      });
    },
  },
  /*created() {
    this.$emit("update:layout", MasterLayout);
  },*/
}
</script>
